class ExpandableTilesGrid
    constructor: (el) ->
        @.$el = el
        @.$tiles = @.$el.querySelectorAll '.expandable-tile'
        @.$tilesGrid = @.$el.querySelector '.expandable-tiles-grid__tiles'

        @.resizeDelay = 300
        @.resizeInterval = undefined

        @.InitEvents()
        @.$el.classList.add 'expandable-tiles-grid--bound'
        return

    CalculateResize: ->
        expandedTile = @.$el.querySelector '.expandable-tile--expanded'
        if expandedTile
            @.CalculateTileStyles expandedTile
        return

    CalculateTileStyles: (tile) ->
        if tile && tile.classList.contains 'expandable-tile'
            tilesRect = @.$tilesGrid.getBoundingClientRect()
            tileRect = tile.getBoundingClientRect()
            tileLeft = tileRect.left - tilesRect.left
            tileExpandedContent = tile.querySelector('.expandable-tile__expanded-content')
            if tileLeft > 0
                tileExpandedContent.style.left = "-#{ tileLeft }px"
            tileExpandedContent.style.minWidth = "#{ @.$tilesGrid.offsetWidth }px"
        return
    
    InitEvents: ->
        self = @
        @.$tiles.forEach (tile) ->
            tile.addEventListener 'expandable-tile-expanded', (e) ->
                self.$tiles.forEach (checkTile) ->
                    if checkTile != e.target
                        if checkTile.classList.contains 'expandable-tile--expanded'
                            checkTile.dispatchEvent new CustomEvent 'expandable-tile-set-expand-state', {
                                bubbles: false
                                detail: {
                                    expand: false
                                }
                            }
                    checkTile.classList.add 'expandable-tile--withdrawn'
                    return                        
                tile.classList.remove 'expandable-tile--withdrawn'
                self.CalculateTileStyles tile
                return
            tile.addEventListener 'expandable-tile-contracted', (e) ->
                expandedTiles = self.$el.querySelectorAll '.expandable-tile--expanded'
                if expandedTiles.length < 1
                    self.$tiles.forEach (checkTile) ->
                        checkTile.classList.remove 'expandable-tile--withdrawn'
                        return
                self.RemoveTileStyles tile
                return
            return

        window.addEventListener 'resize', (e) ->
            window.clearInterval self.resizeInterval
            self.resizeInterval = window.setInterval ->
                window.clearInterval self.resizeInterval
                self.CalculateResize()
            , self.resizeDelay
            return
        return
    
    RemoveTileStyles: (tile) ->
        if tile && tile.classList.contains 'expandable-tile'
            tileExpandedContent = tile.querySelector('.expandable-tile__expanded-content')
            tileExpandedContent.style.removeProperty 'min-width'
            tileExpandedContent.style.removeProperty 'left'
        return

BindExpandableTilesGrids = ->
    document.querySelectorAll '.expandable-tiles-grid:not(.expandable-tiles-grid--bound)'
        .forEach (el) ->
            new ExpandableTilesGrid el
            return
    return

window.addEventListener 'bind-components', BindExpandableTilesGrids